import { render, staticRenderFns } from "./Teaser.html?vue&type=template&id=54088434&"
import script from "./Teaser.vue?vue&type=script&lang=js&"
export * from "./Teaser.vue?vue&type=script&lang=js&"
import style0 from "./Teaser.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports